export const CalcType = {
  PrintingServicesContract: "PrintingServicesContract",
  LegalServicesContract: "LegalServicesContract",
  UniversalLease_ServiceCombined: "UniversalLease_ServiceCombined",
  UniversalLease_ServiceSeparate: "UniversalLease_ServiceSeparate"
};

export const CalcTypeDescription = {
  PrintingServicesContract: "TMVSA",
  LegalServicesContract: "MSSA",
  UniversalLease_ServiceCombined: "Universal Lease – Service Combined",
  UniversalLease_ServiceSeparate: "Universal Lease – Service Separate"
};
